export const RESET_CREATE_STATE = "RESET_CREATE_STATE";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_MAX_STEPS = "SET_MAX_STEPS";
export const RESET_CREATE_DOCUMENTS = "RESET_CREATE_DOCUMENTS";
export const SET_CREATE_DOCUMENTS_RECYCLER_ID =
  "SET_CREATE_DOCUMENTS_RECYCLER_ID";
export const SET_CREATE_DOCUMENTS_ITEMS = "SET_CREATE_DOCUMENTS_ITEMS";
export const SET_CREATE_RESIDUES_ITEMS = "SET_CREATE_RESIDUES_ITEMS";
